<template>
  <div>
    <SambaGlobalSettings></SambaGlobalSettings>
  </div>
</template>

<script>
import SambaGlobalSettings from 'CORE/components/settings/samba/global'

export default {
    name: 'SambaSettingsView',
    components: {
        SambaGlobalSettings,
    },
    data() {
        return {
            data: null,
        }
    },
    created() {
        this.data = this.$store.getters.settings
    },
}
</script>
